import { render } from "./server-tips.vue?vue&type=template&id=7b63c132&scoped=true"
import script from "./server-tips.vue?vue&type=script&lang=js"
export * from "./server-tips.vue?vue&type=script&lang=js"

import "./server-tips.vue?vue&type=style&index=0&id=7b63c132&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b63c132"]])

export default __exports__